import React from "react";

const RetreatIdea = () => {
  return (
    <div className="container">
      <h2 className="article">Идея ретрита</h2>
      <p className="location_text align_center">
        Каждый человек в момент своего рождения получает{" "}
        <span className='bold'>первородную энергию от планет</span> солнечной системы. На нас, как
        часть эволюционного комплекса Земли, наибольшее влияние имеют Солнце,
        Луна, Марс, Меркурий, Юпитер, Венера и Сатурн. Хоть мы и индивидуальны и
        каждый имеет свою уникальную ценностную систему и жизненный опыт,
        энергии планет могут проявлять в нас определённые черты характера и
        влиять на те или иные
        <span className='bold'>процессы в наших физических телах.</span>
      </p>
      <p className="location_text align_center">
        Имея первородные коды планет, которые мы инициируем вам во время
        ретрита, вы сможете <span className='bold'>осознанно использовать энергию</span> той или иной
        планеты себе на благо и получать колоссальные результаты в оздоровлении
        своего тела и эволюции своей души. Вне зависимости от даты вашего
        рождения и положения планет в это время. Также у вас будет возможность
        создать <span className='bold'>планетарные талисманы</span> для себя и близких.
      </p>
      <p className="location_text align_center">
        Ведущие ретрита, Марго и Наталья, <span className='bold'>многие воплощения</span> накапливали
        знания и получали практический опыт работы с энергиям планет для
        исцеления здоровья, трансформации мышления и реализации желаний людей. И
        происходило это в древнейшем и мощнейшем Месте Силы на планете. Раньше
        здесь было наше <span className='bold'>родовое место</span>, где из жизни в жизнь мы
        собирались, чтобы <span className='bold'>нести знания людям</span>. Теперь мы основали здесь
        уникальный ретрит-центр, аналогов которому нет нигде в мире.
      </p>
      <p className="location_text align_center">
        Добро пожаловать в нашу большую и дружную 
        <span className='bold'> семью единомышленников</span>! Почувствуйте себя Дома!
      </p>
      <div className="iframe_wrapper">
        <iframe
          width="832"
          height="468"
          src="https://www.youtube.com/embed/jaRzQJjzR4s?autoplay=1&mute=1&loop=1&playlist=jaRzQJjzR4s"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default RetreatIdea;
